const connect = {
  // 连线的观众列表
  connectedUserList: `/authApi/show/v1/connect/connectedUserList`,
  // 用户连线状态
  userConnectStatus: `/authApi/show/v1/connect/userConnectStatus`
};

export default connect;
